import useUpdate from "@nickeylin/taroify-hooks/use-force-update"

export default useUpdate
